import React, { useState, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Record from './Record';
import Register from './Register';

import {
  Card,
  CardContent,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  Grid
} from '@material-ui/core';

import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Results = ({ resultSet, resultModes, icon, vision, selectedMode, openEdition, openDeletion, openTreatment, openExportDialog, changeSort, dependencies }) => {

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  const handleClick = (event) => {
    if (event.currentTarget.id == 'excel' || event.currentTarget.id == 'csv' || event.currentTarget.id == 'pdf') {
      openExportDialog(event.currentTarget.id);
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };

  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    changeSort(property, order);
  };

  return (
    <Fragment>

      {(screen.width <= 480 || selectedMode == MODE_COMPACT) ? (

        <Box mt={3}>
          <Grid
            container
            spacing={2}
          >
            {(resultModes[MODE_COMPACT].export != LEVEL_ACCESS_HIDE) ? (
              <Grid
                item
                md={12} xl={12} >
                <Card>
                  <CardContent>
                    <Fragment>
                      <Button
                        disabled={resultModes[MODE_COMPACT].export == LEVEL_ACCESS_DISABLED}
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.button}
                        startIcon={<SaveIcon />}
                        aria-controls="simple-menu" component="span" aria-haspopup="true" onClick={handleClick}>
                        Exportar
                      </Button>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={handleClick} name="excel" id="excel" >Planilha do Excel</MenuItem>
                        <MenuItem onClick={handleClick} name="csv" id="csv" disabled>Arquivo de Texto CSV</MenuItem>
                        <MenuItem onClick={handleClick} name="csv" id="pdf" disabled>Arquivo PDF</MenuItem>
                      </Menu>
                    </Fragment>

                  </CardContent>
                </Card>
              </Grid>
            ) : ('')}

            {resultSet.rows.map((item) => (
              <Record
                icon={icon}
                item={item}
                vision={vision}
                resultMode={resultModes[MODE_COMPACT]}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                dependencies={dependencies}>
              </Record>
            ))}
          </Grid>
        </Box>

      ) : (
        <TableContainer component={PerfectScrollbar}>

          <Table stickyHeader size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                {resultModes[MODE_FULL].columns.map((col) => (
                  (col.size != -1) ? (
                    <TableCell width={col.size} >
                      {col.name}
                    </TableCell>
                  ) : (
                    (col.sortable) ? (
                      <TableCell>
                        <TableSortLabel
                          active={orderBy === col}
                          direction={orderBy === col ? order : 'asc'}
                          onClick={createSortHandler(col)}
                        >
                          {col.name}
                        </TableSortLabel>
                      </TableCell>
                    ) : (
                      <TableCell>
                        {col.name}
                      </TableCell>
                    )
                  )
                ))}

                <TableCell align='right' width={200} >
                  {(resultModes[MODE_FULL].export != LEVEL_ACCESS_HIDE) ? (
                    <Fragment>
                      <Button
                        disabled={resultModes[MODE_FULL].export == LEVEL_ACCESS_DISABLED}
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.button}
                        startIcon={<SaveIcon />}
                        aria-controls="simple-menu" component="span" aria-haspopup="true" onClick={handleClick}>
                        Exportar
                      </Button>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={handleClick} name="excel" id="excel" >Planilha do Excel</MenuItem>
                        <MenuItem onClick={handleClick} name="csv" id="csv" disabled>Arquivo de Texto CSV</MenuItem>
                        <MenuItem onClick={handleClick} name="csv" id="pdf" disabled>Arquivo PDF</MenuItem>
                      </Menu>
                    </Fragment>
                  ) : (<div></div>)}

                </TableCell>

              </TableRow>
            </TableHead>

            <TableBody>
              {resultSet.rows.map((item) => (
                <Register
                  icon={icon}
                  item={item}
                  vision={vision}
                  resultMode={resultModes[MODE_FULL]}
                  openEdition={openEdition}
                  openDeletion={openDeletion}
                  openTreatment={openTreatment}
                  dependencies={dependencies}>
                </Register>
              ))}

              {(resultSet.rows.length == 0) ? (
                <TableRow  >
                  <TableCell colSpan={resultModes[MODE_FULL].columns.length + 1} align="center" >
                    {resultModes[MODE_FULL].empty}
                  </TableCell>
                </TableRow>
              ) : ('')}

              <TableRow>
                <TableCell colSpan={resultModes[MODE_FULL].columns.length + 1}>
                  <Typography>
                    Pagina: <b>{resultSet.page}</b> de <b>{resultSet.pages}</b>
                  </Typography>
                </TableCell >
              </TableRow>

            </TableBody>
          </Table>

        </TableContainer>
      )
      }

    </Fragment >
  );
};

export default Results;
